import editDeal from '../../../../api/deals/editDeal';
import setStep from '../../../../api/deals/setStep';
import HookForm from '../../../../components/HookForm/HookForm';
import ProcessDocumentButton from '../../../../components/ProcessDocumentButton/ProcessDocumentButton';
import Select from '../../../../components/Select/Select';
import {
  BANKS,
  DEAL_STATUS_WAITING_FOR_HALYK,
  DEAL_STATUS_WAITING_FOR_REGISTRATION_DOCUMENTS,
  DEAL_STEPS,
  DOCUMENT_TYPES_APPLICATION_FOR_ADDITIONAL_SERVICES,
  DOCUMENT_TYPES_CERTIFICATE_OF_CIRCUMSTANCES,
  DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT,
  DOCUMENT_TYPES_CONTRACT,
  DOCUMENT_TYPES_GUARANTEE_LETTER,
  DOCUMENT_TYPES_INVOICE,
  DOCUMENT_TYPES_POLES,
  DOCUMENT_TYPES_POWER_OF_ATTORNEY,
  DOCUMENT_TYPES_SPOUSE_CONSENT,
  DOCUMENT_TYPES_TECH_PASSPORT,
} from '../../../../constants';
import { BANK_CREDIT_WAITING } from '../../../../constants/bankCreditStatuses';
import alert from '../../../../helpers/alert';
import generateAllowedDocumentsJson from '../../../../utils/generateAllowedDocumentsJson';
const CarRegistration = ({
  loading,
  statusOption = [
    {
      value: DEAL_STATUS_WAITING_FOR_REGISTRATION_DOCUMENTS,
      label: 'ÐÐ¶Ð¸Ð´Ð°ÐµÑ Ð¿Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÐ¸ Ð¢Ð¡ Ð½Ð° ÑÑÐµÑ',
    },
    {
      value: DEAL_STATUS_WAITING_FOR_HALYK,
      label: 'ÐÐ°ÑÐ¸Ð½Ð° Ð¿Ð¾ÑÑÐ°Ð²Ð»ÐµÐ½Ð° Ð½Ð° ÑÑÐµÑ',
    },
  ],
  deal,
  setLoading,
  onSuccess,
  creditAppeal,
}) => {
  const onCarDeliverySubmit = async (values) => {
    if (!values?.status) {
      alert.error('ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð²ÑÐ±ÑÐ°ÑÑ ÑÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸');
      return;
    }
    try {
      await editDeal({
        id: deal?.id,
        dealId: deal?.id,
        statusId: values?.status?.value,
        ...generateAllowedDocumentsJson([
          DOCUMENT_TYPES_CERTIFICATE_OF_CIRCUMSTANCES,
          DOCUMENT_TYPES_GUARANTEE_LETTER,
          DOCUMENT_TYPES_INVOICE,
          DOCUMENT_TYPES_TECH_PASSPORT,
          DOCUMENT_TYPES_CONTRACT,
          DOCUMENT_TYPES_POLES,
          DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT,
          DOCUMENT_TYPES_APPLICATION_FOR_ADDITIONAL_SERVICES,
          DOCUMENT_TYPES_POWER_OF_ATTORNEY,
          DOCUMENT_TYPES_SPOUSE_CONSENT,
        ]),
      });
      if (values?.status?.value === DEAL_STATUS_WAITING_FOR_HALYK) {
        await setStep({ dealId: deal?.id, step: DEAL_STEPS.FORTE.CAR_DELIVERY });
      }

      return onSuccess();
    } catch (e) {
      alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ ÑÐ¼ÐµÐ½Ðµ ÑÑÐ°ÑÑÑÐ° ÑÐ´ÐµÐ»ÐºÐ¸');
      setLoading(false);
      return;
    }
  };

  return (
    <>
      <div style={{ marginBottom: 20 }}>
        <HookForm
          title={'Ð ÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ Ð¢Ð¡'}
          grid={{ display: 'grid', gap: 20 }}
          action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ'}
          inputs={[
            {
              label: 'Ð¡ÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸',
              name: 'status',
              component: Select,
              options: statusOption,
              required: true,
            },
          ]}
          onSubmit={onCarDeliverySubmit}
          loading={loading}
          // backHandler={() => (
          //   <>
          //     {creditAppeal?.bankId == BANKS.EURAZ && creditAppeal?.statusId == BANK_CREDIT_WAITING ? (
          //       <ProcessDocumentButton chunkId={deal?.chunkId} />
          //     ) : null}
          //   </>
          // )}
        />
      </div>
    </>
  );
};

export default CarRegistration;
